import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { validateMerchant } from './actions'
import { ApplePayError, ApplePayStatus, PaymentSourceCaptureCardTypes } from '../../model'
import { PURGE } from 'redux-persist'
import { closeCheckout } from '../actions'

export interface ApplePayState {
  status: ApplePayStatus
  error?: ApplePayError
  isEnabledForDevice: boolean
  cardType?: PaymentSourceCaptureCardTypes
  isCreditCardDisabled: boolean
}

export const applePayInitialState: ApplePayState = {
  status: ApplePayStatus.Initial,
  isEnabledForDevice: false,
  isCreditCardDisabled: false,
}

const applePaySlice = createSlice({
  name: 'applepay',
  initialState: applePayInitialState,
  reducers: {
    setApplePayStatus(state: ApplePayState, action: PayloadAction<ApplePayStatus>) {
      state.status = action.payload
    },
    setApplePayFailure(state: ApplePayState, action: PayloadAction<ApplePayError>) {
      state.status = ApplePayStatus.Error
      state.error = action.payload
    },
    resetApplePayError(state: ApplePayState) {
      state.status = ApplePayStatus.Initial
      state.error = undefined
    },
    setIsEnabledForDevice(state: ApplePayState, action: PayloadAction<boolean>) {
      state.isEnabledForDevice = action.payload
    },
    setIsCreditCardDisabled(state: ApplePayState, action: PayloadAction<boolean>) {
      state.isCreditCardDisabled = action.payload
    },
    setApplePayCardType(state: ApplePayState, action: PayloadAction<PaymentSourceCaptureCardTypes>) {
      state.cardType = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateMerchant.rejected, (state, action) => {
        state.error = ApplePayError.MerchantValidationFailed
      })
      .addCase(closeCheckout, () => applePayInitialState)
      .addCase(PURGE, () => applePayInitialState)
  },
})

export const { resetApplePayError, setApplePayStatus, setApplePayFailure, setIsEnabledForDevice, setApplePayCardType, setIsCreditCardDisabled } =
  applePaySlice.actions
export default applePaySlice.reducer
